import React from 'react';
import { motion } from 'framer-motion';
import { X, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const ServiceModal = ({ service, onClose }) => {
  const Icon = service.icon;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="relative max-w-3xl w-full bg-zinc-900/90 backdrop-blur-sm rounded-2xl overflow-hidden border border-white/10 max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-10 w-10 h-10 rounded-full bg-black/50 hover:bg-black/70 text-white flex items-center justify-center transition"
        >
          <X size={24} />
        </button>

        <div className="p-6 md:p-8">
          <div className="flex items-center gap-4 mb-4">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-purple-500/20 to-indigo-500/20 flex items-center justify-center">
              <Icon size={28} className="text-purple-400" />
            </div>
            <h2 className="text-2xl md:text-3xl font-serif font-bold text-white">{service.title}</h2>
          </div>

          <div className="space-y-6">
            <p className="text-gray-300 leading-relaxed">{service.longDescription}</p>

            {service.videoEmbed && (
              <div className="relative aspect-video w-full rounded-xl overflow-hidden border border-white/10">
                <iframe
                  // src={service.videoEmbed}
                  title={`${service.title} video`}
                  className="absolute inset-0 w-full h-full"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            )}

            <div className="flex flex-wrap gap-2">
              {service.features.map((feature, idx) => (
                <span key={idx} className="text-xs px-3 py-1 rounded-full bg-purple-500/20 text-purple-300 border border-purple-500/20">
                  {feature}
                </span>
              ))}
            </div>

            <div className="pt-4 border-t border-white/10 flex flex-wrap gap-4">
              <Link
                to={`/portfolio?filter=${service.filterValue}`}
                onClick={onClose}
                className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-gradient-to-r from-purple-600 to-indigo-600 text-white font-medium hover:shadow-lg hover:shadow-purple-500/30 transition"
              >
                View Projects <ArrowRight size={16} />
              </Link>
              <Link
                to="/contact"
                onClick={onClose}
                className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-white/20 text-white font-medium hover:bg-white/5 transition"
              >
                Inquire Now
              </Link>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default ServiceModal;